import type { ZodSafeParseError } from "zod"
import type { $ZodIssue as ZodIssue } from "zod/v4/core"
import ApplicationError from "./ApplicationError.js"
import ErrorCode from "./ErrorCode.js"

/**
 * @description
 *	A general validation error of some model.
 */
export default class ValidationError extends ApplicationError<{ errors: ZodIssue[] }> {
	public constructor(output: ZodSafeParseError<unknown>, pathOverride: (number | string)[] | undefined = undefined) {
		super(ErrorCode.ValidationError, "The schema of the provided model is invalid.", {
			errors: ValidationError.fulfill(output.error.issues, pathOverride)
		})
	}

	private static fulfill(issues: ZodIssue[], pathOverride: (number | string)[] | undefined): ZodIssue[] {
		if (pathOverride !== undefined) {
			return issues.map(issue => ({ ...issue, path: pathOverride }))
		} else {
			return issues
		}
	}
}
